//----- Component --------------------------------------------------------/
// Developer     : Guillermo Sedran
// Creation Date : 02/05/2025
// Version       : 1
// Description   : Carga de productos nuevos desde el guardado del reporte
//
//------Changes --------------------------------------------------------------------- -------------//
// Change Date   :
// Change by     :
// Change description:
//
// Change Date   :
// Change by     :
// Change description:
//
//========================================================================/

import React, { useState, useEffect } from "react";
import { UrlApi } from "../../services/apirest";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  Stack,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  DialogActions,
  TextField,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid";

// Notification
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function CargaProductosEnReporte({ open, productos, onCancel, onConfirm }) {
  const [unidades, setUnidades] = useState([]);
  const [selecciones, setSelecciones] = useState({});

  useEffect(() => {
    fetch(UrlApi + "/productos_reporte/unidad")
      .then((res) => res.json())
      .then(setUnidades)
      .catch(console.error);
  }, []);

  // Notification state
  const [openSnack, setOpenSnack] = useState(false);
  const [mensaje, setMensaje] = useState("");
  const [severity, setSeverity] = useState("success");
  const [disBtn, setDisBtn] = useState(false);

  const almacenar = (e) => {
    const { name, value } = e.target;
    setSelecciones((prev) => ({
      ...prev,
      [name]: value, // valor siempre un id
    }));
  };

  // ******************************************************

  // Cada vez que la lista de productos cambia reinicio el objeto "selecciones" para que tenga UNA ENTRADA por cada producto,
  // todas inicializadas en null (sin unidad elegida aún).
  useEffect(() => {
    const inicial = {};
    productos.forEach((nombre) => {
      // Creo una propiedad con clave igual al nombre del producto y valor null
      inicial[nombre] = null;
    });
    setSelecciones(inicial);
  }, [productos]);

  // allSelected es "true" cuando:
  // 1) El número de claves en `selecciones` coincida con la cantidad de productos, asegurando que hay valor para todos los productos.
  // 2) Ninguno de los valores sea null (cada producto ya tiene unidad elegida)
  const allSelected =
    Object.values(selecciones).length === productos.length && // Mismas claves que productos
    Object.values(selecciones).every((v) => v != null); // Todas las selecciones no-null

  // ******************************************************

  const handleGuardar = async () => {
    setDisBtn(true); // Deshabilitar botón

    const nuevos = Object.entries(selecciones).map(([nombre, unidad]) => ({
      nombre: nombre.trim(),
      unidad,
      estado: 1, // Se guarda con estado activo
    }));

    try {
      await onConfirm(nuevos);
    } catch (err) {
      setSeverity("error");
      setMensaje(err.message || "Error al crear productos");
      setOpenSnack(true);
    } finally {
      setDisBtn(false);
    }
  };

  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") return;
    setOpenSnack(false);
  };

  return (
    <Dialog open={open} onClose={onCancel} fullWidth maxWidth="sm">
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "#2B76A6",
          width: "100%",
          padding: "8px 0",
        }}
      >
        <Typography
          variant="h6"
          color="white"
          sx={{
            textAlign: "center",
          }}
        >
          Asignación de Productos Nuevos
        </Typography>
      </Box>

      <DialogContent>
        <Grid container spacing={2}>
          {productos.map((nombre) => (
            <React.Fragment key={nombre}>
              <Grid item xs={8}>
                <TextField
                  fullWidth
                  label="Producto"
                  size="small"
                  value={nombre}
                  disabled
                />
              </Grid>
              <Grid item xs={4}>
                <FormControl fullWidth size="small">
                  <InputLabel>Unidad</InputLabel>
                  <Select
                    name={nombre}
                    value={selecciones[nombre] ?? ""}
                    label="Unidad"
                    onChange={almacenar}
                  >
                    {unidades.map((u) => (
                      <MenuItem key={u.id} value={u.id}>
                        {u.unidad} ({u.abreviatura})
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </React.Fragment>
          ))}
        </Grid>
      </DialogContent>

      <DialogActions>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Button variant="contained" color="error" onClick={onCancel}>
              Volver
            </Button>
          </Grid>
          <Grid item xs={6} sx={{ textAlign: "right" }}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleGuardar}
              disabled={!allSelected || disBtn}
            >
              Guardar Productos
            </Button>
          </Grid>
        </Grid>
      </DialogActions>

      <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar
          open={openSnack}
          autoHideDuration={1500}
          onClose={handleCloseSnack}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={handleCloseSnack}
            severity={severity}
            sx={{ width: "100%" }}
          >
            {mensaje}
          </Alert>
        </Snackbar>
      </Stack>
    </Dialog>
  );
}

export default CargaProductosEnReporte;
